// Exported constants, based on:
// https://stackoverflow.com/questions/8595509/how-do-you-share-constants-in-nodejs-modules

export var Constants = Object.freeze({
  START_OF_SYSEX:   0xf0,
  END_OF_SYSEX:     0xf7
});

// module.exports = Object.freeze({
//   START_OF_SYSEX:   0xf0,
//   END_OF_SYSEX:     0xf7
// });



// WEBPACK FOOTER //
// ./src/constants.js